import { createContext, useContext } from "react";

/** Interface */
interface IMeasurementsContext {
	type: "manager" | "controlling";
	userId: string | undefined;
}

/** Context */
export const MeasurementsContext = createContext<IMeasurementsContext>({} as IMeasurementsContext);

/** Hooks */
export function useMeasurementsContext() {
	return useContext(MeasurementsContext);
}
